export class PerfilamientoMasterRespuestasHijas {
  idRespuestaHija: number;
  idRespuestaPadre: number;
  descripcionRespuesta: string;
  idUsuarioUM: number;
  fechaHoraUM: string;
  seleccion:boolean =false;
}
